import React, { FC } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../../theme/styles";
import { ChangesFormActionsProps } from "./changesFormActionsProps";

const ChangesFormActions: FC<ChangesFormActionsProps> = (props) => {
	const {
		isValid,
		isDirty,
		isSubmitting,
		disableSave,
		saveTooltip,
		handleReset,
		hideFormButtons,
		isSaveAction,
		handleSubmit,
		formId,
	} = props;

	const shouldShow = isDirty !== undefined ? isDirty : isValid;

	const { t } =
		typeof jest !== "undefined" ? { t: (s) => s } : useTranslation();
	const classes = useStyles();

	const handleCancel = () => {
		handleReset();
		if (hideFormButtons) {
			hideFormButtons();
		}
	};

	const handleFormSubmit = (e: React.FormEvent) => {
		if (handleSubmit) {
			handleSubmit();
			e.preventDefault();
		}
	};

	return (
		<Box
			sx={{
				display: shouldShow ? "flex" : "none",
				justifyContent: "flex-end",
				pb: 2,
				pt: 2,
				pr: 2,
			}}
		>
			<Button
				disabled={isSubmitting}
				variant="contained"
				type="button"
				className={classes.cancelButton}
				onClick={handleCancel}
				data-testid="btnCancel"
			>
				{t("Shared.Cancel")}
			</Button>
			{isSaveAction && (
				<Tooltip title={saveTooltip ?? ""}>
					<span>
						<Button
							disabled={isSubmitting || disableSave}
							type="submit"
							form={formId}
							variant="contained"
							className={classes.saveButton}
							data-testid="btnSave"
						>
							{t("Shared.Save")}
						</Button>
					</span>
				</Tooltip>
			)}
			{!isSaveAction && (
				<Tooltip title={saveTooltip ?? ""}>
					<span>
						<Button
							disabled={isSubmitting || disableSave}
							variant="contained"
							type="submit"
							form={formId}
							className={classes.saveButton}
							onClick={(e) => handleFormSubmit(e)}
							data-testid="btnSave"
						>
							{t("Shared.Save")}
						</Button>
					</span>
				</Tooltip>
			)}
		</Box>
	);
};

ChangesFormActions.propTypes = {
	// @ts-ignore
	isValid: PropTypes.bool,
	isSubmitting: PropTypes.bool,
	handleReset: PropTypes.func,
	hideFormButtons: PropTypes.func,
	isSaveAction: PropTypes.bool,
};

export default ChangesFormActions;
